interface ActionType {
  GET_WEB_HOOK_SUBSCRIPTIONS_START: string;
  GET_WEB_HOOK_SUBSCRIPTIONS_SUCCESS: string;
  GET_WEB_HOOK_SUBSCRIPTIONS_FAILURE: string;
  ADD_WEB_HOOK_SUBSCRIPTION_START: string;
  ADD_WEB_HOOK_SUBSCRIPTION_SUCCESS: string;
  ADD_WEB_HOOK_SUBSCRIPTION_FAILURE: string;
  UPDATE_WEB_HOOK_SUBSCRIPTION_START: string;
  UPDATE_WEB_HOOK_SUBSCRIPTION_SUCCESS: string;
  UPDATE_WEB_HOOK_SUBSCRIPTION_FAILURE: string;
  DELETE_WEB_HOOK_SUBSCRIPTION_START: string;
  DELETE_WEB_HOOK_SUBSCRIPTION_SUCCESS: string;
  DELETE_WEB_HOOK_SUBSCRIPTION_FAILURE: string;
  RESET_WEB_HOOK_SUBSCRIPTION: string;
  GET_WEB_HOOK_NOTIFICATION_HISTORY_START: string;
  GET_WEB_HOOK_NOTIFICATION_HISTORY_SUCCESS: string;
  GET_WEB_HOOK_NOTIFICATION_HISTORY_FAILURE: string;
  GET_WEB_HOOK_NOTIFICATION_DETAILS_START: string;
  GET_WEB_HOOK_NOTIFICATION_DETAILS_SUCCESS: string;
  GET_WEB_HOOK_NOTIFICATION_DETAILS_FAILURE: string;
  REDELIVER_WEB_HOOK_NOTIFICATION_START: string;
  REDELIVER_WEB_HOOK_NOTIFICATION_SUCCESS: string;
  REDELIVER_WEB_HOOK_NOTIFICATION_FAILURE: string;
  SET_NOTIFICATION_HISTORY_SEARCH_FILTER: string;
  SET_NOTIFICATION_HISTORY_SEARCH_ORDER_BY: string;
}

export const WebhookActionTypes: ActionType = {
  GET_WEB_HOOK_SUBSCRIPTIONS_START: '@@GET_WEB_HOOK_SUBSCRIPTIONS_START',
  GET_WEB_HOOK_SUBSCRIPTIONS_SUCCESS: '@@GET_WEB_HOOK_SUBSCRIPTIONS_SUCCESS',
  GET_WEB_HOOK_SUBSCRIPTIONS_FAILURE: '@@GET_WEB_HOOK_SUBSCRIPTIONS_FAILURE',
  ADD_WEB_HOOK_SUBSCRIPTION_START: '@@ADD_WEB_HOOK_SUBSCRIPTION_START',
  ADD_WEB_HOOK_SUBSCRIPTION_SUCCESS: '@@ADD_WEB_HOOK_SUBSCRIPTION_SUCCESS',
  ADD_WEB_HOOK_SUBSCRIPTION_FAILURE: '@@ADD_WEB_HOOK_SUBSCRIPTION_FAILURE',
  UPDATE_WEB_HOOK_SUBSCRIPTION_START: '@@UPDATE_WEB_HOOK_SUBSCRIPTION_START',
  UPDATE_WEB_HOOK_SUBSCRIPTION_SUCCESS:
    '@@UPDATE_WEB_HOOK_SUBSCRIPTION_SUCCESS',
  UPDATE_WEB_HOOK_SUBSCRIPTION_FAILURE:
    '@@UPDATE_WEB_HOOK_SUBSCRIPTION_FAILURE',
  DELETE_WEB_HOOK_SUBSCRIPTION_START: '@@DELETE_WEB_HOOK_SUBSCRIPTION_START',
  DELETE_WEB_HOOK_SUBSCRIPTION_SUCCESS:
    '@@DELETE_WEB_HOOK_SUBSCRIPTION_SUCCESS',
  DELETE_WEB_HOOK_SUBSCRIPTION_FAILURE:
    '@@DELETE_WEB_HOOK_SUBSCRIPTION_FAILURE',
  RESET_WEB_HOOK_SUBSCRIPTION: '@@RESET_WEB_HOOK_SUBSCRIPTION',
  GET_WEB_HOOK_NOTIFICATION_HISTORY_START:
    '@@GET_WEB_HOOK_NOTIFICATION_HISTORY_START',
  GET_WEB_HOOK_NOTIFICATION_HISTORY_SUCCESS:
    '@@GET_WEB_HOOK_NOTIFICATION_HISTORY_SUCCESS',
  GET_WEB_HOOK_NOTIFICATION_HISTORY_FAILURE:
    '@@GET_WEB_HOOK_NOTIFICATION_HISTORY_FAILURE',
  GET_WEB_HOOK_NOTIFICATION_DETAILS_START:
    '@@GET_WEB_HOOK_NOTIFICATION_DETAILS_START',
  GET_WEB_HOOK_NOTIFICATION_DETAILS_SUCCESS:
    '@@GET_WEB_HOOK_NOTIFICATION_DETAILS_SUCCESS',
  GET_WEB_HOOK_NOTIFICATION_DETAILS_FAILURE:
    '@@GET_WEB_HOOK_NOTIFICATION_DETAILS_FAILURE',
  REDELIVER_WEB_HOOK_NOTIFICATION_START:
    '@@REDELIVER_WEB_HOOK_NOTIFICATION_START',
  REDELIVER_WEB_HOOK_NOTIFICATION_SUCCESS:
    '@@REDELIVER_WEB_HOOK_NOTIFICATION_SUCCESS',
  REDELIVER_WEB_HOOK_NOTIFICATION_FAILURE:
    '@@REDELIVER_WEB_HOOK_NOTIFICATION_FAILURE',
  SET_NOTIFICATION_HISTORY_SEARCH_FILTER:
    '@@SET_NOTIFICATION_HISTORY_SEARCH_FILTER',
  SET_NOTIFICATION_HISTORY_SEARCH_ORDER_BY:
    '@@SET_NOTIFICATION_HISTORY_SEARCH_ORDER_BY'
};

export interface WebhookState {
  subscriptions?: WebhookSubscriptionState;
  notifications?: WebhookNotificationState;
}

export interface WebhookSubscriptionState {
  personalList?: any[];
  allList?: any[];
  selected?: any;
  error?: string;
  submitting?: boolean;
}

export interface WebhookNotificationState {
  allList?: any[];
  allListInfo?: any;
  selected?: any;
  error?: string;
  submitting?: boolean;
  notificationDetails?: any;
  allListFilters?: any;
  isLoading?: boolean;
  isRedeliver?: boolean;
  allListOrderBy?: string;
}

export interface WebhookSubscriptionAddPayload {
  webhook: string;
  url: string;
  clientKey: string;
  customHeaders?: [{ name: string; value: string }];
  isPaused: boolean;
  organisationId?: number;
}

export interface WebhookSubscriptionUpdatePayload {
  subscriptionId: number;
  data: WebhookSubscriptionUpdateData;
}

export interface WebhookSubscriptionUpdateData {
  isPaused?: boolean;
  clientKey?: string;
  customHeaders?: [{ name: string; value: string }];
}

export interface WebhookSubscriptionEventItem {
  status: 'subscribed' | 'paused' | 'empty';
  label: string;
  type: string;
  id?: number;
  organisationId?: number;
}

export interface WebhookSubscriptionResponse {
  webhook: string;
  url: string;
  clientKey: string;
  customHeaders?: [{ name: string; value: string }];
  isPaused: boolean;
  id: number;
  organisationId?: number;
  createdAt: string;
  updatedAt: string;
}

export interface WebhookSubscriptionFormProps {
  submitting: boolean;
  deleting: boolean;
  isUpdate: boolean;
  eventLabel: string;
  disableDeleted: boolean;
  handleCancel: Function;
  handleDelete: Function;
  apiCalled: boolean;
}

export interface WebhookSubscriptionFormValues {
  url: string;
  clientKey: string;
  customHeaders?: [{ name: string; value: string }];
  isPaused: boolean;
}

export interface WebhookSubscriptionFormTouched {
  url?: boolean;
  clientKey?: boolean;
  customHeaders?: boolean;
  isPaused?: boolean;
}

export interface WebhookNotificationSearchParams {
  order?: string;
  limit?: number;
  offset?: number;
  fields?: string;
  filter?: string;
}

export enum WEB_HOOK_SUBSCRIPTION_EVENT_TYPE {
  ENQUIRY_CREATE = 'enquiry:create',
  REFERRAL_CREATE = 'referral:create',
  REFERRAL_UPDATE = 'referral:update',
  USER_CREATE = 'user:create',
  USER_UPDATE = 'user:update',
  RESPONSE_CREATE = 'response:create'
}

export interface WebhookNotificationHistoryFormInitialValues {
  dateRange: string;
  createdAfter: string;
  createdBefore: string;
  status: string[];
  webhook: string[];
}

export type EventStatus = 'DELIVERED' | 'CREATED' | 'FAILED' | 'TIMED_OUT';
